<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div :class="resignType == '4' ? 'modal-dialog resign-modal-dialog' : 'modal-dialog'">
            <div class="modal-content">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">撥出對象-{{ segmentName }}</h3>
                </div>
                <div class="modal-body">
                    <section class="search pb-0 mb-3">
                        <div class="row">
                            <div class="col-8 d-flex align-items-center">
                                轄下內單位資訊:
                            </div>
                             <div class="col-4 text-right">
                               <a class="btn btn-default" @click="download()" >下載本頁資料</a>
                            </div>
                        </div>
                    </section>
                    <table class="segment-table table datatable table-striped table-bordered">
                        <thead>
                            <tr>
                                <th width="65px" class="sorting"
                                    :class="orderIndex == 'div_short_name' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('div_short_name')">單位<br>名稱</th>
                                <th width="80px" class="sorting"
                                    :class="orderIndex == 'avg_service_per_person' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('avg_service_per_person')">人均服務件數</th>
                                <th width="80px" class="sorting"
                                    :class="orderIndex == 'avg_apc_per_person' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('avg_apc_per_person')">人均要保人數</th>
                                <th width="70px" class="sorting"
                                    :class="orderIndex == 'new_agent_count' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('new_agent_count')">新人數</th>
                                <th width="90px" class="sorting"
                                    :class="orderIndex == 'count_tmp7' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('count_tmp7')">撥件<br>未達門檻<br>新人數</th>
                                <th width="80px" class="sorting"
                                    :class="orderIndex == 'n_remain' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('n_remain')">未訪要保人數</th>
                                <th width="90px" class="sorting"
                                    :class="orderIndex == 'rate_6' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('rate_6')">本年度<br>6個月內<br>實質接觸率</th>
                                <th width="90px" class="sorting"
                                    :class="orderIndex == 'apc_count' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                                    @click="orderby('apc_count')">近30日<br>已撥出<br>要保人數</th> 
                                <th width="*">備註</th>
                            </tr>
                        </thead>
                        <tbody v-if="sortedUnitsList.length > 0">
                            <tr v-for="(d, did) in sortedUnitsList" :key="`td-${did}`">
                                <td width="65px">{{ d.div_short_name }}</td>
                                <td width="80px">{{ d.avg_service_per_person }}</td>
                                <td width="80px">{{ d.avg_apc_per_person }}</td>
                                <td width="70px">{{ d.new_agent_count || 0 }}</td>
                                <td width="90px">{{ d.count_tmp7 || 0 }}</td>
                                <td width="80px">{{ d.n_remain || 0 }}</td>
                                <td width="90px">{{ d.rate_6 || 0 }}%</td>
                                <td width="90px">{{ d.apc_count || 0 }}</td>
                                <td width="*">
                                    <a class="btn btn-sm link text-left"
                                        style="min-width: 52px;background: transparent;"
                                        @click="$emit('queryUnit', d)">查詢
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8" class="empty">
                                    <h3 class="text-center py-5">無客戶資料</h3>
                                </td>
                                <td v-show="false"></td>
                                <td v-show="false"></td>
                                <td v-show="false"></td>
                                <td v-show="false"></td>
                                <td v-show="false"></td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-12 text-right">
                            <button type="button" @click="$emit('close')" class="btn btn-default">取消</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <resign-modal :open="resignModalOpen" :cedvno3="cedvno3" @close="panelClose('resignModalOpen')"
            @close-all="doCloseAllModal" />

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { commonMixin } from "@/mixins/common";
import ResignModal from "@/desktop/components/manager/ResignModal";
import { downloadRegionalUnvisitedInfo } from '@/service'

export default {
    name: 'DialOutUnitModal',
    mixins: [commonMixin],
    components: { ResignModal },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        segmentUnitsList: {
            type: Array,
            default: () => {
                return []
            },
        },
        segmentName: {
            type: String,
            default: () => {
                ''
            },
        },
        // 1: 專招, 4: 展業
        resignType: {
            type: String,
            default: ""
        }
    },
    watch: {
        open: function () {
            this.updateList()
        },
    },
    data() {
        return {
            checkAll: false,
            clickTarget: '',
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            years: '',
            unitsList: [],
            yearsOpt: [],
            resignModalOpen: false,
            cedvno3: "",
            confirmModalOpen: false,
            resignInfo: {},
            orderIndex: '',
            orderAsc: true,

        }
    },
    computed: {
        sortedUnitsList(){
            if (!this.orderIndex) return this.unitsList;

            const isStringField = this.orderIndex === 'div_short_name';

            // 複製一份新陣列進行排序，強迫 Vue 2 觸發響應式更新
            return [...this.unitsList].sort((itemA, itemB) => {
                let valA = itemA[this.orderIndex];
                let valB = itemB[this.orderIndex];

                if (isStringField) {
                    valA = valA !== undefined && valA !== null ? String(valA) : '';
                    valB = valB !== undefined && valB !== null ? String(valB) : '';
                    
                    return this.orderAsc 
                        ? valA.localeCompare(valB, 'zh-Hant') 
                        : valB.localeCompare(valA, 'zh-Hant');
                } else {
                    if (typeof valA === 'string' && valA.includes('%')) valA = valA.replace('%', '');
                    if (typeof valB === 'string' && valB.includes('%')) valB = valB.replace('%', '');

                    valA = valA !== undefined && valA !== null && valA !== '' ? parseFloat(valA) : 0;
                    valB = valB !== undefined && valB !== null && valB !== '' ? parseFloat(valB) : 0;

                    if (isNaN(valA)) valA = 0;
                    if (isNaN(valB)) valB = 0;

                    return this.orderAsc ? valA - valB : valB - valA;
                }
            });
        }
    },
    methods: {
        updateList() {
            this.years = ''
            this.keyowrd = ''
            this.unitsList = []
            // 開啟視窗時，重置排序狀態
            this.orderIndex = ''
            this.orderAsc = true
            
            const vm = this
            setTimeout(() => {
                vm.unitsList = [...vm.segmentUnitsList]
                this.registerHanlink()  // 難字 update
            }, 100);
        },
        orderby(indexName) { // 排序表格
            if (this.orderIndex !== indexName) {
                this.orderIndex = indexName;
                this.orderAsc = true;
            } else {
                this.orderAsc = !this.orderAsc; // 同欄位切換正反序
            }
        },
        download(){
            const cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
            downloadRegionalUnvisitedInfo(this.$store.state.userInfo.id, cedvno3, "S", "區部未訪件").then(result => {
                if (result.type == "application/json") {
                //  json 為檔案下載失敗
                //  把回傳的 blob 轉為 文字檔後再用 json parse
                let reader = new FileReader();
                reader.onload = function() {
                    let unicodeJsonA = JSON.parse(reader.result);
                    if (unicodeJsonA.header.message) {
                    vm.setToastMsg(unicodeJsonA.header.message);
                    } else {
                    vm.setToastMsg("伺服器連線異常");
                    }
                };
                reader.readAsText(result);
                } else {
                //  成功取得檔案  進行下載
                const currentDateStr = new Date().toLocaleDateString('zh-TW', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(/\//g, '');
                const fileName = `轄下單位服務件與調撥參考資訊-${currentDateStr}.xlsx`;
                saveAs(result, fileName);
                }
            });
        },
        /**
         * 查詢離退人員清單
         * @param {Object} empData 
         */
        queryResignList(empData) {
            this.selection = [];
            this.selection.push(empData);
            this.cedvno3 = empData.clcno.substring(0, 3);
            this.panelOpen("resignModalOpen");
        },
        /** 關閉已開啟的modal  */
        doCloseAllModal: function () {
            this.panelClose("resignModalOpen");
            if (this.resignType === "4" || this.resignType === "1") {
                const resignInfo = this.$store.state.resignInfo
                this.selection.forEach(item => item.is_unlock = resignInfo.is_unlock)
            }
            this.$emit("close-resign", this.selection);
        },
    }
};
</script>

<style lang="scss" scoped>
.table.datatable thead tr>th:first-child {
    padding-left: 10px;
}

.table.datatable tbody tr>td {
    font-size: 14px;
}

.table.datatable tbody tr>td:first-child {
    padding-left: 10px;
    padding-top: 10px;
}

.segment-table thead tr,
.segment-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.segment-table tbody tr {
    height: 54px;
}

.segment-table tbody {
    display: block;
    height: 300px;
    overflow-y: scroll;
    border: 0 !important;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        width: 17px;
        border: 0;
        box-shadow: none;
    }

    &::-webkit-scrollbar-track {
        box-shadow: none;
        border-radius: 0px;
        border: 0;
        background-color: #F5F5F5;
    }

    &::-webkit-scrollbar-thumb {
        width: 10px;
        border-radius: 20px;
        background-color: #555;
    }
}

.segment-table th {
    font-size: 14px;
}

.resign-modal-dialog {
    width: 1000px !important;
}

button.btn.btn-sm,
.btn.btn-sm {
    padding: 2px 0px;
}
</style>